import React from 'react'
// import { Link } from 'react-router-dom'
import BGVideo from "../../assets/img/bg/bdrc-bg.png"
// import Play from "../../assets/img/bg/play-button.png"

function Take() {

    // const [yShow, setyShow] = useState()
    // const [hShow, sethShow] = useState()

  return (
    <>
<section
  id="video"
  className="video-area pt-150 pb-150 p-relative"
  style={{
    backgroundImage: `url(${BGVideo})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
  }}
>
                <div className="content-lines-wrapper2">
                    <div className="content-lines-inner2">
                        <div className="content-lines2"></div>
                    </div>
                </div>
                <div className="container">                   
                     <div className="row">
                        <div className="col-12">
                            <div className="s-video-wrap">
                                <div className="s-video-content">
                                    {/* <Link to="#" className="popup-video" onClick={() => setyShow(true)}><img src={Play} alt="circle_right"/></Link> */}
                                </div>
                            </div>
                            {/* <div className="section-title center-align text-center">
                                <h2>
                                 Visitános
                                </h2>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
    </>
  )
}

export default Take